import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size?: number;
  color?: string;
};

export default function WhatsAppSvgIcon({
  size = 18,
  color = "#111827",
}: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12.05 3.1a8.55 8.55 0 0 0-7.3 12.98L3.8 20.9l4.7-1.1a8.55 8.55 0 1 0 3.55-16.7Zm0 2.2a6.35 6.35 0 1 1-2.82 12.03l-.35-.18-2.24.52.46-2.3-.2-.35A6.35 6.35 0 0 1 12.05 5.3Z"
        fill={color}
      />
      <Path
        d="M9.68 8.05c-.2-.45-.42-.46-.62-.47h-.53c-.18 0-.48.07-.73.35-.25.27-.96.95-.96 2.32 0 1.36.99 2.68 1.13 2.87.14.18 1.9 3.04 4.72 4.14 2.34.91 2.82.73 3.33.68.51-.04 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.11-.25-.18-.53-.32l-1.8-.9c-.27-.13-.46-.2-.66.1-.2.29-.76.9-.93 1.08-.17.2-.34.21-.62.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.4-1.66-1.56-1.94-.17-.28-.02-.43.12-.57.13-.12.28-.33.42-.5.14-.16.18-.28.27-.47.09-.18.04-.35-.02-.49l-.84-1.93Z"
        fill={color}
      />
    </Svg>
  );
}
